import React, { useState, useEffect } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import stylesMenu from "../../styles/Atoms/SubMenu/subMenu";
import { Typography } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import "../../Traduccion_ES_EN/i18nMiCuenta";

const SubMenu = ({
  user,
  loggout = () => {},
  showLogoutOption = false,
  menuOptions = [],
  menuTrigger = "click",
  color,
  fontWeight,
  isScrolling = false,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { t } = useTranslation();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleTriggerEvent =
    menuTrigger === "hover"
      ? { onMouseEnter: handleOpenMenu }
      : { onClick: handleOpenMenu };

  return (
    <>
      <Button
        aria-controls="simple-menu"
        aria-haspopup="true"
        style={{
          ...stylesMenu.button,
          color: color || (isScrolling ? "#0979b0" : "white"),
          fontWeight: fontWeight || (isScrolling ? "600" : "normal"),
          fontFamily: "Raleway,sans-serif",
        }}
        {...handleTriggerEvent}
      >
        {user}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        sx={{ position: "fixed" }}
      >
        {menuOptions
          .filter((option) => option.includeInMenu !== false)
          .map((option, index) => (
            <MenuItem
              key={index}
              onClick={handleCloseMenu}
              component={Link}
              to={option.link || "#"}
              sx={{ fontFamily: "Raleway,sans-serif" }}
            >
              {option.label}
            </MenuItem>
          ))}
        {showLogoutOption && (
          <MenuItem
            onClick={() => {
              handleCloseMenu();
              loggout();
            }}
            sx={{ fontFamily: "Raleway,sans-serif" }}
          >
            {t("Welcome.text190")}
          </MenuItem>
        )}
        <Divider />
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            color: "#474747",
            margin: "0 15px",
            fontFamily: "Raleway,sans-serif",
          }}
        >
          {t("Welcome.text303")}
        </Typography>
      </Menu>
    </>
  );
};

export default SubMenu;
